import React from 'react';
import ReportCardGrid, { Report } from '../shared/ReportCardGrid';

const emailReports: Report[] = [
        // {
        //     title: 'Email Agent Performance Report',
        //     description: "A comprehensive analysis of agent performance metrics.",
        //     to: '/email-agent-performance-report',
        //     image: "https://fonolo.com/wp-content/uploads/2023/09/Agent-Performance-IMAGE.png"
        // },
        {
            title: 'Email SL Report',
            description: "An in-depth look at email service level agreements and response times.",
            to: '/email-sla-report',
            image: "https://www.venminder.com/hubfs/Blog_Images/2023_Blog_Posts/04.04.2023-tracking-vendor-performance-with-service-level-agreements-FEATURED.jpg"
        },
          
        {
            title: 'Email Report',
            description: "A comprehensive overview of email performance metrics and analytics.",
            to: '/email-report',
            image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQoTghKI9HXALySPgRK9TP6eEGel9S5M9E5zw&s"
        }
    ];

const EmailReportsList = () => {
  return (
    <ReportCardGrid
      reports={emailReports}
      sectionTitle="Email"
      basePath="/reports/email"
    />
  );
};

export default EmailReportsList;
